import {queryOptions, useQuery} from '@tanstack/react-query'
import * as z from 'zod'
import * as sdk from '@cypro/server/sdk'

const PublicSettingsSchema = z.object({
  loginText: z.string().nullable(),
  logoUrl: z.string().nullable(),
  language: z.string().nullable(),
})

export type PublicSettings = z.infer<typeof PublicSettingsSchema>

export const publicSettingsQueryOptions = queryOptions({
  queryKey: ['public-settings'],
  queryFn: async () => {
    const response = await sdk.getPublicSettings()
    if (response.error) {
      throw new Error('Failed to fetch public settings')
    }
    return PublicSettingsSchema.parse(response.data)
  },
  staleTime: 5 * 60 * 1000,
})

export function useGetPublicSettings() {
  const {data, ...rest} = useQuery(publicSettingsQueryOptions)
  return {
    ...rest,
    settings: data ?? null,
  }
}

export function useSuspenseGetPublicSettings() {
  const {data, ...rest} = useQuery(publicSettingsQueryOptions)
  return {
    ...rest,
    settings: data ?? null,
  }
}